import "./filter-form.scss";
// import AddFilterNew from "../AddFilterNew";
import InputField from "@_common/InputRuleFeild";
import SearchableDropdownSelect from "@_common/SearchableDropdown";
import { getValue } from "@utils/lodash";
import { Col, Row } from "reactstrap";
import ResetSvgComponent from "../../../../assets/svg-components/reset";


export default function FilterForm(props: any) {
	const {
		handleChangeSelect,
		countryList,
		states,
		categoryOfLawList,
		legislationList,
		ruleList,
		locations,
		additionalFilter,
		smartFilterList,
		selectedSmartFilterIds,
		handleChangeSelectMulti,
		//loading...
		categoryLawLoading,
		legislationLoading,
		legislationRuleLoading,
		locationLoading,
		functionLoading,
		resetInput
	} = props;

	return (
		<div
		className={`filter-slidder-wrapper  ${
			props.filterIsOpen ? "filter-slidder-wrapper--active" : ""
		}`}
		>
			<div className="filter-form-wrappper w-100 active">
				<div className="filter-form-wrappper__container">
					{/* <div className="d-flex align-items-center justify-content-between my-3">
						<h6 className="filter-form-wrappper__title">Filter by</h6>
						<img
							src="/images/close-black.svg"
							className="img-fluid cursor-pointer"
							onClick={props.handleFilter}
						/>
					</div> */}
					<div className="filter-header-wrapper d-flex align-items-center justify-content-between">
						<div className="filter-header-left-wrapper d-flex align-items-center">
						<div className="filter-close-wrapper">
							<img src="/images/close-circle.svg" className="img-fluid cursor-pointer" onClick={props.handleFilter} />
						</div>
						<div className="filter-title-wrapper">
							<h6 className="filter-form-wrappper__title">Filter</h6>
						</div>
						
						<div className="filter-module-details-wrapper">
							<div className="filter-module-name">{props.moduleName}</div>
							<div className="filter-submodule-name">{props.subModuleName}</div>
						</div>
						</div>

						<div className="filter-header-right-wrapper">
						{/* <div className="filter-form-wrappper__cta-wrapper p-0 d-flex">
						{!getValue(props, `hideReset`, false) && (
							<button
								className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--reset"
								onClick={props.reset}
							>
								<div className="d-flex align-items-center mt--3">
								<ResetSvgComponent  size={24} color={"#5F6368"} /> Reset
								</div>
							</button>
							)}

							<button
							className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--cancel"
							onClick={props.handleFilter}
							>
							Cancel
							</button>
							<button
							className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--search"
							onClick={props.handleSubmitSmartFilter}
							>
							{getValue(props, `submitText`, "")
								? getValue(props, `submitText`, "")
								: "Search"}
							</button>
						</div> */}
						<div className="filter-form-wrappper__cta-wrapper d-flex p-0">
							<button
								className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--reset"
								onClick={props.reset}
							>
								<div className="d-flex align-items-center mt--3">
									<ResetSvgComponent  size={24} color={"#5F6368"} /> Reset
								</div>
							</button>

							<button
							className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--cancel"
							onClick={props.handleFilter}
							>
								Cancel
							</button>
							{props.country_ID.length > 0 ||
							props.state_ID.length > 0 ||
							props.cat_ID.length > 0 ||
							props.leg_ID.length > 0 ||
							props.rule_ID.length > 0 ? (
								<button
									className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--search"
									onClick={props.handleSubmitSmartFilter}
								>
									Search
								</button>
							) : (
								<button
									className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--disable"
									onClick={props.handleSubmitSmartFilter}
								>
									Search
								</button>
							)}
							
						</div>
						</div>
					</div>
					
					<div className="filter-body-wrapper">
						<div className="filter-body-card">
							<div className="filter-card-title">
								Filter By
							</div>
							<div className="d-flex justify-content-between flex-column">
								<div className="filter-form-wrappper__location">
									<div className="d-flex w-100 filter-field-main-wrap">
										<div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
											<label htmlFor="country" className="filter-form-wrappper__label filter-fields-label">
												Country
											</label>
											<div className="filter-form-wrappper__location-input">
												<InputField
													inputType="INPUT_REACT_SELECT"
													placeholder="Choose Country"
													className="form-control w-100"
													name="country_id"
													id="country_id"
													options={countryList}
													value={props.country_ID}
													onChange={(e: any) => handleChangeSelect(e, "country_id")}
													label="Country"
												/>
											</div>
										</div>

										<div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
											<label htmlFor="state" className="filter-form-wrappper__label filter-fields-label">
												State
											</label>
											<div className="filter-form-wrappper__location-input">
												<InputField
													inputType="INPUT_REACT_SELECT"
													placeholder="Choose State"
													className="form-control w-100"
													name="state_id"
													id="state_id"
													label="Last Name"
													options={states}
													value={props.state_ID}
													onChange={(e: any) => handleChangeSelect(e, "state_id")}
													isClear
												/>
											</div>
										</div>
									</div>
									
									<div className="d-flex w-100 filter-field-main-wrap">
										<div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
											<label htmlFor="law" className="filter-form-wrappper__label filter-fields-label">
												Category of Law
											</label>
											<div className="filter-form-wrappper__location-input select-dd-new">
												{/* <InputField
													inputType="INPUT_REACT_SELECT"
													placeholder="Choose Category of Law"
													className="form-control w-100"
													name="category_of_law_id"
													id="category_of_law_id"
													label="Category Law"
													options={categoryOfLawList}
													value={props.cat_ID}
													onChange={(e: any) =>
														handleChangeSelect(e, 'category_of_law_id')
													}
													isClear
												/> */}
												<SearchableDropdownSelect
													placeholder={"Choose Category of Law"}
													options={categoryOfLawList}
													searchLoading={categoryLawLoading}
													handleChange={(val: any) => props.getCategoryLawList(val)}
													handleClick={(e: any) =>
														props.handleChangeSelect(e, "category_of_law_id")
													}
													value={getValue(props, `cat_ID[${0}]`, {})}
													label="label"
													id="id"
													name="Category of Law"
													resetInput={resetInput}
												/>
											</div>
										</div>

										<div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
											<label
												htmlFor="legislation"
												className="filter-form-wrappper__label filter-fields-label"
											>
												Legislation
											</label>
											<div className="filter-form-wrappper__location-input select-dd-new">
												{/* <InputField
													inputType="INPUT_REACT_SELECT"
													placeholder="Choose Legislation"
													className="form-control w-100"
													name="legislation_id"
													id="legislation_id"
													label="Legislation ID"
													options={legislationList}
													value={props.leg_ID}
													onChange={(e: any) => handleChangeSelect(e, "legislation_id")}
													isClear
												/> */}
												<SearchableDropdownSelect
													placeholder={"Choose Legislation"}
													options={legislationList}
													searchLoading={legislationLoading}
													handleChange={(val: any) => props.getLegislationList(val)}
													handleClick={(e: any) =>
														props.handleChangeSelect(e, "legislation_id")
													}
													value={getValue(props, `leg_ID[${0}]`, {})}
													label="label"
													id="id"
													name="Legislation"
													resetInput={resetInput}
												/>
											</div>
										</div>
									</div>
									
									<div className="d-flex w-100 filter-field-main-wrap">
										<div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
											<label htmlFor="rule" className="filter-form-wrappper__label filter-fields-label">
												Rule
											</label>

											<div className="filter-form-wrappper__location-input select-dd-new">
												{/* <InputField
													inputType="INPUT_REACT_SELECT"
													placeholder="Choose Rule"
													className="form-control w-100"
													name="legislation_rule_id"
													id="legislation_rule_id"
													label="Legislation Rule ID"
													options={ruleList}
													value={props.rule_ID}
													onChange={(e: any) =>
														handleChangeSelect(e, "legislation_rule_id")
													}
													isClear
												/> */}
												<SearchableDropdownSelect
													placeholder={"Choose Legislation Rule"}
													options={ruleList}
													searchLoading={legislationRuleLoading}
													handleChange={(val: any) => props.getLegislationRuleList(val)}
													handleClick={(e: any) =>
														props.handleChangeSelect(e, "legislation_rule_id")
													}
													value={getValue(props, `rule_ID[${0}]`, {})}
													label="label"
													id="id"
													name="Legislation Rule"
													resetInput={resetInput}
												/>
											</div>
										</div>
									</div>
								</div>
								<div className="filter-form-wrappper__location">
									{/* <div className="filter-form-wrappper__location-form-group form-group">
										<label htmlFor="state" className="filter-form-wrappper__label filter-fields-label">
											Checkpoint
										</label>
										<div className="filter-form-wrappper__location-input">
											<InputField
												inputType="INPUT_REACT_SELECT"
												placeholder="Choose State"
												className="form-control w-100"
												name="checkpoint_id"
												id="checkpoint_id"
												label="Last Name"
												options={props.checkpointList}
												value={props.checkpoint_id}
												onChange={(e: any) => handleChangeSelect(e, "checkpoint_id")}
												isClear
											/>
										</div>
									</div>
									<div className="filter-form-wrappper__location-form-group form-group">
										<label htmlFor="state" className="filter-form-wrappper__label filter-fields-label">
											Frequency
										</label>
										<div className="filter-form-wrappper__location-input">
											<InputField
												inputType="INPUT_REACT_SELECT"
												placeholder="Choose State"
												className="form-control w-100"
												name="frequency_id"
												id="frequency_id"
												label="Last Name"
												options={props.frequencyList}
												value={props.frequency_id}
												onChange={(e: any) => handleChangeSelect(e, "frequency_id")}
												isClear
											/>
										</div>
									</div> */}
									
									<div className="d-flex w-100 filter-field-main-wrap">
										<div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
											<label htmlFor="state" className="filter-form-wrappper__label filter-fields-label">
												Locations
											</label>
											<div className="filter-form-wrappper__location-input select-dd-new">
												{/* <InputField
													inputType="INPUT_REACT_SELECT"
													placeholder="Choose Loaction"
													className="form-control w-100"
													name="location_id"
													id="location_id"
													label="Last Name"
													options={props.locations}
													value={props.location_id}
													onChange={(e: any) => handleChangeSelect(e, "location_id")}
													isClear
												/> */}
												<SearchableDropdownSelect
													placeholder={"Choose Location"}
													options={locations}
													searchLoading={locationLoading}
													handleChange={(val: any) => props.getLocationList(val)}
													handleClick={(e: any) =>
														props.handleChangeSelect(e, "location_id")
													}
													value={getValue(props, `location_id[${0}]`, {})}
													label="label"
													id="id"
													name="Location"
													resetInput={resetInput}
												/>
											</div>
										</div>

										<div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
										<label htmlFor="state" className="filter-form-wrappper__label filter-fields-label">
											Functions
										</label>
										<div className="filter-form-wrappper__location-input select-dd-new">
											{/* <InputField
												inputType="INPUT_REACT_SELECT"
												placeholder="Choose Function"
												className="form-control w-100"
												name="function_id"
												id="function_id"
												label="Last Name"
												options={props.functions}
												value={props.function_id}
												onChange={(e: any) => props.getLocationFunctions(e, "function_id")}
												isClear
											/> */}
											<SearchableDropdownSelect
												placeholder={"Choose Function"}
												options={props.functions}
												searchLoading={functionLoading}
												handleChange={(val: any) => props.getLocationFunctions(val)}
												handleClick={(e: any) =>
													props.handleChangeSelect(e, "function_id")
												}
												value={getValue(props, `function_id[${0}]`, {})}
												label="label"
												id="id"
												name="Function"
												resetInput={resetInput}
											/>
										</div>
									</div>
									</div>
								</div>

								{additionalFilter && (
									<div className="filter-form-wrappper__location filter-form-wrappper__container border-bottom-0 mb-0">
										<div className="d-flex w-100 filter-field-main-wrap">
											<div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap mb-0">
												<label htmlFor="state" className="filter-form-wrappper__label filter-fields-label">
													Additional Filter
												</label>
												<div className="filter-form-wrappper__location-input filter-form-wrappper__location-input--law">
													{/* <Row>
														<Col md="4"> */}
															<InputField
																inputType="INPUT_REACT_SELECT"
																placeholder="Choose Additional Filter"
																className="form-control"
																name="legislation_rule_id"
																id="legislation_rule_id"
																label="Legislation Rule ID"
																options={smartFilterList}
																value={selectedSmartFilterIds}
																onChange={(e: any) => handleChangeSelectMulti(e)}
																isMulti
															/>
														{/* </Col>
													</Row> */}
												</div>
											</div>
										</div>

										{/* <h6 className="filter-form-wrappper__title py-2">
											Additional Filter
										</h6> */}
										
										{/* <div className="filter-form-wrappper__location my-2">
											<div className="filter-form-wrappper__location-form-group form-group">
												<label htmlFor="country" className="filter-form-wrappper__label filter-fields-label">
													Tags
												</label>
												<div className="filter-form-wrappper__location-input">
													<input
														type="text"
														placeholder="Choose Tags"
														id="country"
														className="filter-form-wrappper__form-control form-control"
													/>
													<img
														src="/images/arrow-drop.svg"
														className="img-fluid filter-form-wrappper__image"
													/>
												</div>
											</div>
										</div> */}
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
				
				<div className="filter-form-wrappper__cta-wrapper d-none">
					{props.country_ID.length > 0 ||
					props.state_ID.length > 0 ||
					props.cat_ID.length > 0 ||
					props.leg_ID.length > 0 ||
					props.rule_ID.length > 0 ? (
						<button
							className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--search"
							onClick={props.handleSubmitSmartFilter}
						>
							Search
						</button>
					) : (
						<button
							className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--disable"
							onClick={props.handleSubmitSmartFilter}
						>
							Search
						</button>
					)}
					<button
						className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--reset"
						onClick={props.reset}
					>
						Reset
					</button>
				</div>

				{/* <AddFilterNew /> */}
			</div>
		</div>
	);
}
